import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ActivityModal = ({ isOpen, onClose, onSave, dayNumber, editingActivity }) => {
  const [formData, setFormData] = useState({
    time: '',
    title: '',
    description: '',
    cost: 0,
    category: 'activity'
  });

  useEffect(() => {
    if (editingActivity) {
      setFormData(editingActivity);
    } else {
      setFormData({
        time: '',
        title: '',
        description: '',
        cost: 0,
        category: 'activity'
      });
    }
  }, [editingActivity]);

  const categoryOptions = [
    { value: 'activity', label: 'Activity' },
    { value: 'food', label: 'Food & Dining' },
    { value: 'transport', label: 'Transportation' },
    { value: 'wellness', label: 'Wellness' },
    { value: 'sightseeing', label: 'Sightseeing' },
    { value: 'shopping', label: 'Shopping' },
    { value: 'entertainment', label: 'Entertainment' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave(dayNumber, formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card rounded-xl border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-foreground">
              {editingActivity ? 'Edit Activity' : 'Add New Activity'}
            </h2>
            <p className="text-sm text-muted-foreground mt-1">Day {dayNumber}</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Input
              type="time"
              label="Time"
              required
              value={formData?.time}
              onChange={(e) => handleChange('time', e?.target?.value)}
              placeholder="Select time"
            />

            <Select
              label="Category"
              required
              options={categoryOptions}
              value={formData?.category}
              onChange={(value) => handleChange('category', value)}
            />
          </div>

          <Input
            type="text"
            label="Activity Title"
            required
            value={formData?.title}
            onChange={(e) => handleChange('title', e?.target?.value)}
            placeholder="e.g., Island Hopping Tour"
          />

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Description
            </label>
            <textarea
              value={formData?.description}
              onChange={(e) => handleChange('description', e?.target?.value)}
              placeholder="Add details about this activity..."
              rows={4}
              className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none"
            />
          </div>

          <Input
            type="number"
            label="Cost (₱)"
            required
            value={formData?.cost}
            onChange={(e) => handleChange('cost', parseFloat(e?.target?.value) || 0)}
            placeholder="0"
            min="0"
            step="0.01"
          />

          {/* Actions */}
          <div className="flex gap-3 pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              size="lg"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              size="lg"
              fullWidth
              iconName="Save"
              iconPosition="left"
            >
              {editingActivity ? 'Update Activity' : 'Add Activity'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActivityModal;